import fetchData from "./axios-instance";

const forgotPassword = async (email) => {
    const url = `/forgot-password`;
    const res = await fetchData.get(url, {params: {"email": email}});
    return res;
}

export default forgotPassword;